import React, { useEffect, useState } from 'react';

import { useLoading } from '../../../commons/Loading';
import { useAuth } from '../../../commons/Auth';
import { useTranslation } from 'react-i18next';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import { useDebouncedCallback } from 'use-debounce';
import { getReportsVariableRevenuesRecurrentEnergy } from '../../../lib/fetch/reports';
import VarRevRecurrentEnergyDetailPaginatedPresentational from './VarRevRecurrentEnergyDetailPresentational';
import { useAlert } from 'react-alert';

const VarRevRecurrentEnergyDetail = (props) => {
  const { profile = {} } = props;

  const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;
  const { _id: profileId } = profile;
  const { showLoading, hideLoading } = useLoading();
  const [{ newToken } = {}] = useAuth();
  const alert = useAlert();
  const [t] = useTranslation('CONTACTS');
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(NumberParam, new Date().getFullYear()),
    energyRecurrentPod: withDefault(StringParam, ''),
    energyRecurrentCondoVat: withDefault(StringParam, ''),
    energyRecurrentAccountabilityYear: NumberParam,
    energyRecurrentAccountabilityMonth: NumberParam,
    customerType: withDefault(StringParam, ''),
    contractType: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    year,
    search,
    energyRecurrentPod,
    energyRecurrentCondoVat,
    energyRecurrentAccountabilityYear,
    energyRecurrentAccountabilityMonth,
    customerType,
    contractType,
  } = query;

  const [fetchReportsRevenuesRecurrentEnergy] = useDebouncedCallback(
    async () => {
      showLoading();
      const response = await getReportsVariableRevenuesRecurrentEnergy({
        limit,
        offset,
        year,
        search,
        energyRecurrentPod,
        energyRecurrentCondoVat,
        energyRecurrentAccountabilityYear,
        energyRecurrentAccountabilityMonth,
        newToken,
        customerType,
        profileId,
        contractType,
      });

      hideLoading();

      if (response instanceof Error) {
        return alert.error(t('COMMON:GENERIC_ERROR'));
      }

      const { data = [] } = response;
      setReports(data);
      setTotal(data.categories?.variableRevenuesRecurrentEnergy?.count);
    },
    1000
  );

  useEffect(() => {
    fetchReportsRevenuesRecurrentEnergy();
  }, [
    limit,
    offset,
    year,
    customerType,
    search,
    energyRecurrentPod,
    energyRecurrentCondoVat,
    energyRecurrentAccountabilityYear,
    energyRecurrentAccountabilityMonth,
    contractType,
  ]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.energyRecurrentAccountabilityYear &&
        queryDiff.energyRecurrentAccountabilityYear !==
          energyRecurrentAccountabilityYear) ||
      queryDiff.energyRecurrentAccountabilityYear === ''
    ) {
      queryDiff.energyRecurrentAccountabilityMonth = '';
    }

    if (
      (queryDiff.customerType && queryDiff.customerType !== customerType) || // first search
      (customerType && queryDiff.customerType === '') ||
      (queryDiff.contractType && queryDiff.contractType !== contractType) || // first search
      (contractType && queryDiff.contractType === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0;
    }
    setQuery(queryDiff);
  }

  return (
    <VarRevRecurrentEnergyDetailPaginatedPresentational
      data={reports}
      onFilter={onFilter}
      total={total}
      profileType={profile.type}
      query={query}
      {...props}
    />
  );
};

export default VarRevRecurrentEnergyDetail;
